import {Route, UrlSegment} from '@angular/router';
import {fnValidUuid} from '@shared/utils/fn.valid.uuid';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';

export const TEAMS_ROUTES: Route = {
  path: EEndpointApp.Teams,
  children: [
    {
      path: ':teamId',
      canMatch: [
        (_route: Route, segments: UrlSegment[]) => {
          return fnValidUuid(segments[0]?.path);
        },
      ],
      children: [
        {
          path: EEndpointApp.Members,
          title: 'team_members',
          loadComponent: () => import('./members/members.component').then((c) => c.MembersComponent),
        },
        {
          path: EEndpointApp.Invitations,
          loadComponent: () => import('./invitations/invitations.component').then((c) => c.InvitationsComponent),
        },
      ],
    },
    {
      path: EEndpointApp.Overview,
      title: 'access_to_teams',
      loadComponent: () => import('./overview/overview.component').then((m) => m.OverviewComponent),
    },
    {
      path: '',
      redirectTo: EEndpointApp.Overview,
      pathMatch: 'prefix',
    },
  ],
};
